import React, { useState } from 'react';
import { Category } from 'components/CategoryList/CategoryList';
import ListItemSubcategory from 'components/CategoryList/ListItemSubcategory';

interface IProps {
    category: Category;
    index: number;
    carId: string;
}

const CategoryListItem = (props: IProps) => {
    const { category, index, carId } = props;
    const id = `cat-${index}${category.assemblyGroupNodeId}${carId}`;

    return (
        <div className="category-tree__group" key={id}>
            <input type="checkbox" id={id} />
            <label htmlFor={id}>{category.assemblyGroupName}</label>

            {category.hasChilds && <ListItemSubcategory categories={category.children} carId={carId} />}
        </div>
    );
};

export default CategoryListItem;
